import { Navigate, type RouteObject } from "react-router";
import { DifferentiationRoute } from "./[differentiationId]/differentiation-route";
import { DifferentiationIndexRoute } from "./[differentiationId]/differentiation/_components/differentiation-index-route";
import { DifferentiationsIndexRoute } from "./_components/differentiations-index-route";
import CountingIndexRoute from "./[differentiationId]/counting/counting-index-route";

export const differentiationsRoute: RouteObject[] = [
  {
    index: true,
    element: <DifferentiationsIndexRoute />,
  },
  {
    path: ":differentiationId",
    element: <DifferentiationRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="differentiation" />,
      },
      {
        path: "differentiation",
        element: <DifferentiationIndexRoute />,
      },
      {
        path: "counting",
        element: <CountingIndexRoute />,
      },
    ],
  },
];
